import { render } from "./JourneyVehicle.vue?vue&type=template&id=274e271b"
import script from "./JourneyVehicle.vue?vue&type=script&lang=js"
export * from "./JourneyVehicle.vue?vue&type=script&lang=js"
script.render = render

export default script